/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import {
	Nav4Filters as Nav4FiltersWithoutErrorBoundary,
	type Nav4FiltersProps,
} from './ui/filters/Nav4Filters.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';

export const Nav4Filters = (props: Nav4FiltersProps): React.JSX.Element => (
	<UFOSegment name="nav4-sidebar-filters">
		<JSErrorBoundary
			fallback="flag"
			id="filters-section"
			packageName={PACKAGE_NAME}
			teamName={TEAM_NAME}
		>
			<Nav4FiltersWithoutErrorBoundary {...props} />
		</JSErrorBoundary>
	</UFOSegment>
);
